// English translations for the components area, keyed by the Russian source string.
export default {
  // order/edit.js
  'Ошибка при получении списка стран': 'Error fetching the list of countries',
  'Ошибка при получении списка филиалов': 'Error fetching the list of branches',
  'Введите адрес доставки!': 'Enter the delivery address!',
  'Отправление успешно изменено': 'Shipment updated successfully',
  'Заполните все поля формы': 'Fill in all form fields',
  'Ошибка': 'Error',
  'Выберите, откуда отправить!': 'Choose where to send from!',
  'Выберите филиал получения': 'Select a pickup branch',
  'Выберите филиал получения!': 'Select a pickup branch!',
  'Выбрать': 'Select',
  'Выберите тип отправления': 'Select shipment type',
  'Выберите тип отправления!': 'Select shipment type!',
  'Выберите отправителя и получателя': 'Select a sender and a receiver',
  'Доставить по адресу в Кыргызстане? (стоимость доставки в Кыргызстане рассчитывается отдельно)':
    'Deliver to an address in Kyrgyzstan? (delivery cost in Kyrgyzstan is calculated separately)',
  'Адрес доставки': 'Delivery address',
  'Введите адрес доставки': 'Enter the delivery address',
  'Выберите стоимость отправляемого отправления:': 'Select the value of the shipment being sent:',
  'Введите стоимость отправления!': 'Enter the shipment value!',
  'Выберите тип оплаты': 'Select payment type',
  'Выберите тип оплаты!': 'Select payment type!',
  'Наличные': 'Cash',
  'Перевод': 'Transfer',
  'Карта': 'Card',
  'В Кыргызстане': 'In Kyrgyzstan',
  'Комментарий': 'Comment',
  'Сохранить': 'Save',

  // order/orderTypeSelection.js
  'Тип отправления добавлен': 'Shipment type added',
  'Тип отправления удалён': 'Shipment type removed',
  'Выберите отправляемое отправление': 'Select the item to send',
  'Добавить тип отправления': 'Add shipment type',
  'Выйти': 'Sign out',
  'тип': 'type',

  // order/partyChooser.js
  'Больше загрузить нельзя...': 'Nothing more to load...',
  'Отправитель успешно добавлен': 'Sender added successfully',
  'Получатель успешно добавлен': 'Receiver added successfully',
  'Невозможно удалить выбранного получателя': 'Cannot delete the selected receiver',
  'Этот получатель сейчас выбран. Выберите другого получателя, затем удалите.':
    'This receiver is currently selected. Select another receiver, then delete.',
  'Получатель успешно удалён': 'Receiver deleted successfully',
  'Невозможно удалить выбранного отправителя': 'Cannot delete the selected sender',
  'Этот отправитель сейчас выбран. Выберите другого отправителя, затем удалите.':
    'This sender is currently selected. Select another sender, then delete.',
  'Отправитель успешно удалён': 'Sender deleted successfully',
  'Выберите данные отправителя и получателя': 'Select sender and receiver details',
  'Данные отправителя': 'Sender details',
  'Данные получателя': 'Receiver details',
  'Выбрать отправителя': 'Select sender',
  'Выбрать получателя': 'Select receiver',
  'Адрес недоступен': 'Address unavailable',
  'Вы уверены, что хотите удалить отправителя?': 'Are you sure you want to delete the sender?',
  'Вы уверены, что хотите удалить получателя?': 'Are you sure you want to delete the receiver?',
  'Нет': 'No',
  'Да': 'Yes',
  'Нет отправителей': 'No senders',
  'Нет получателей': 'No receivers',
  'Добавить нового отправителя': 'Add a new sender',
  'Добавить нового получателя': 'Add a new receiver',
  'Добавить отправителя': 'Add sender',
  'Добавить получателя': 'Add receiver',
  'Тип отправителя': 'Sender type',
  'Физическое лицо': 'Individual',
  'Организация': 'Organization',
  'Введите название организации!': 'Enter the organization name!',
  'Название организации': 'Organization name',
  'Имя': 'First name',
  'Введите имя!': 'Enter a first name!',
  'Введите фамилию!': 'Enter a last name!',
  'Фамилия': 'Last name',
  'Телефон': 'Phone',
  'Эл. почта': 'Email',
  'Введите адрес!': 'Enter an address!',
  'Введите город/аймаг!': 'Enter city/aimag!',
  'Город/Аймаг': 'City/Aimag',
  'Введите район/сомон!': 'Enter district/soum!',
  'Район/Сомон': 'District/Soum',
  'Введите хороо/баг!': 'Enter khoroo/bag!',
  'Хороо/Баг': 'Khoroo/Bag',
  'Квартира/Дом': 'Apartment/House',

  // search-field-with-key-up-listener.js
  'Поиск': 'Search',

  // base/priceSelect/index.js
  'Другое': 'Other',
  'Стоимость отправления': 'Shipment value',
  'Сумма': 'Amount',

  // estimated-delivery-date/index.js
  'Дата доставки просрочена': 'Delivery date is overdue',
  'Дата доставки приближается': 'Delivery date is approaching',
  'Дата доставки ещё не наступила': 'Delivery date has not arrived yet',
  'Дата доставки успешно сохранена!': 'Delivery date saved successfully!',
  'Предупреждение': 'Warning',
  'Дата доставки всех отправлений этого груза будет обновлена. Продолжить?':
    'The delivery date for all shipments in this cargo will be updated. Continue?',

  // mainlayout.js
  'Отправления': 'Orders',
  'Пакет отправлений': 'Bulk orders',
  'Отгрузки': 'Shipments',
  'Пользователи': 'Users',
  'Настройки': 'Settings',
  'Отчёты': 'Reports',
  'Таможня': 'Customs',
  'Профиль': 'Profile',
  'Админ': 'Admin',
  'Вы уверены, что хотите выйти?': 'Are you sure you want to sign out?',

  // kiosk/num-pad.js
  'Очистить': 'Clear',
  'США': 'USA',
  'Кыргызстан': 'Kyrgyzstan',
  'Номер телефона': 'Phone number',
  'ПИН-код': 'PIN code',
}
